import { FC } from 'react'
import styles from 'components/features/creditCard/creditCardComparisonChart/CardNeverAppliedPreset/CardNeverAppliedPreset.styl'
import { Chart } from 'components/features/creditCard/creditCardComparisonChart/Chart/Chart'
import { Controls } from 'components/features/creditCard/creditCardComparisonChart/Controls/Controls'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { CardPickerNoCards } from 'components/features/creditCard/creditCardComparisonChart/CardPickerNoCards/CardPickerNoCards'
import { useChartData } from 'components/features/creditCard/creditCardComparisonChart/useChartData'
import Flex from 'components/atoms/Flex/Flex'

export const CardNeverAppliedPreset: FC = () => {
  const {
    setParams,
    statusPoints,
    points,
    lastStatusPoints,
    cardsAmount,
  } = useChartData()

  return (
    <section className={ styles.cardsComparison }>
      <h1 className={ styles.title }>
        Your rewards could be worth <span>{ formatUSCurrency(lastStatusPoints) }</span><br />
        in the next <b>5</b> years.<sup>*</sup>
      </h1>
      <Flex horizontallyCenter>
        <div className={ styles.controls }>
          <Controls onChange={ setParams } />
        </div>
        <div className={ styles.chart }>
          <Chart
            statusData={ statusPoints }
            comparisonData={ points.no_crypto }
          />
        </div>
        <Flex className={ styles.picker } theme='info' padding='defaultSize' shrinkHeight shrinkWidth>
          <CardPickerNoCards cardsAmount={ cardsAmount } />
        </Flex>
      </Flex>
    </section>
  )
}


